<template>
  <div>
    <UpdateWorkshopTasksViaExcelModal
      v-if="showUpdateWorkshopTasksViaExcelModal"
      :family="familyActive"
      @hidden="showUpdateWorkshopTasksViaExcelModal = false"
      @updateDone="updateDone"
    />
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h2>Tareas de taller</h2>
          <p>
            En este apartado se pueden gestionar las tareas de taller de las
            diferentes familias de productos.
          </p>
          <p>Haz click en una familia de productos:</p>

          <b-list-group horizontal>
            <b-list-group-item
              button
              @click="familyActive = familyOption"
              v-for="familyOption in familyOptions"
              :key="familyOption"
              :active="familyActive === familyOption"
              >{{ familyOption }}</b-list-group-item
            >
          </b-list-group>

          <b-row class="mt-4" v-if="familyActive">
            <b-col :cols="12">
              <h3>
                Listado de tareas de la familia de productos {{ familyActive }}
              </h3>
              <v-server-table
                name="workshop-tasks"
                :url="tableURI"
                ref="table"
                class="mt-4"
                :columns="table.columns"
                :options="table.options"
              >
                <div slot="afterFilterWrapper" class="form-group form-inline">
                  <!-- <b-button
                    class="ml-3"
                    variant="primary"
                    :to="{
                      name: 'AdminWorkshopTasksEditScreen',
                      params: { id: 'new' },
                    }"
                    >Nueva tarea</b-button
                  > -->

                  <!-- <b-button
                    variant="outline-danger"
                    class="ml-2"
                    :disabled="table.selected.length === 0"
                    @click="removeSelected()"
                    >Eliminar seleccionadas</b-button
                  > -->

                  <b-button variant="outline-secondary" @click="downloadExcel()"
                    >Descargar Excel</b-button
                  >

                  <b-button
                    class="ml-3"
                    @click="showExcelModal()"
                    variant="outline-secondary"
                    >Subir Excel</b-button
                  >
                </div>

                <div slot="h__checkbox">
                  <b-form-checkbox
                    v-model="table.allSelected"
                    @change="toggleAll"
                  />
                </div>

                <div slot="checkbox" slot-scope="props">
                  <b-form-checkbox
                    :checked="table.selected.includes(props.row.code)"
                    @change="toggleCell($event, props.row.code)"
                  />
                </div>

                <template v-slot:preview="props">
                  <img
                    style="max-height: 100px; max-width: 100px"
                    :src="props.row.icon"
                  />
                </template>

                <template v-slot:code_hex="props">
                  <span>#{{ props.row.code_hex }}</span>
                </template>

                <!-- <template v-slot:actions="props">
                  <b-button
                    :to="{
                      name: 'AdminWorkshopTasksEditScreen',
                      params: { id: props.row.code },
                    }"
                    size="sm"
                    variant="outline-primary"
                    class="mr-2"
                    >Editar</b-button
                  >

                  <b-button
                    @click="removeWorkshopTask(props.row.code)"
                    size="sm"
                    variant="outline-danger"
                    class="mr-2"
                    >Eliminar</b-button
                  >
                </template> -->
              </v-server-table>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { uris, actions } from '@/admin/api.js';

import store from '@/admin/store.js';
import UpdateWorkshopTasksViaExcelModal from '@/admin/components/workshopTasks/UpdateWorkshopTasksViaExcelModal.vue';

export default {
  name: 'AdminWorkshopTasksScreen',
  props: {},
  components: { UpdateWorkshopTasksViaExcelModal },
  data() {
    return {
      showUpdateWorkshopTasksViaExcelModal: false,
      familyOptions: [],
      familyActive: null,
      table: {
        selected: [],
        allSelected: false,
        columns: ['checkbox', 'code', 'description'], // 'actions'],
        options: {
          perPage: 100,
          filterable: false,
          saveState: true,
          sortable: ['code'],
          headings: {
            code: 'Código',
            description: 'Descripción',
            // actions: 'Acciones',
          },
        },
      },
      sharedState: store.state,
    };
  },
  created() {
    actions.getWorkshopTaskFamilies().then((x) => {
      this.familyOptions = x.data;
      store.setOverlayShow(false);
    });
  },
  methods: {
    showExcelModal() {
      this.$bvModal
        .msgBoxConfirm(
          'Al subir el Excel se borrarán las tareas de taller actuales, incluída su relación con productos. ¿Deseas continuar?',
          {
            title: 'Atención',
            size: 'md',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'Continuar',
            cancelTitle: 'Cancelar',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value) {
            this.showUpdateWorkshopTasksViaExcelModal = true;
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    updateDone() {
      this.showUpdateWorkshopTasksViaExcelModal = false;
      this.$refs.table.refresh();
    },
    downloadExcel() {
      actions
        .postWorkshopTasksDownloadExcel(this.familyActive)
        .then((x) => {
          // let fileName = 'stock.csv';

          let fileName = 'tareas_de_taller.xlsx';

          const contentDisposition = x.headers['content-disposition'];
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename=(.+)/);
            console.log('CDD', contentDisposition, fileNameMatch);
            if (fileNameMatch.length === 2) {
              fileName = fileNameMatch[1];
            }
          }

          const url = window.URL.createObjectURL(new Blob([x.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
        })
        .catch((y) => {});
    },
    removeSelected() {
      this.table.selected.map((x) => {
        this.removeWorkshopTask(x);
      });
    },
    removeWorkshopTask(id) {
      actions.deleteWorkshopTask(id).then((x) => {
        this.$refs.table.refresh();
      });
    },
    toggleCell($event, id) {
      if ($event) {
        this.table.selected.push(id);
      } else {
        this.table.selected = this.table.selected.filter((item) => item !== id);
      }
    },
    toggleAll(checked) {
      this.table.selected = checked
        ? this.$refs.table.data.map((row) => row.code)
        : [];
    },
  },
  mounted() {},
  computed: {
    tableURI() {
      if (!this.familyActive) return null;

      return `${uris.workshopTasksPerFamilyURI(this.familyActive)}`;
    },
  },
};
</script>

<style scoped></style>
